import { Center, Flex, Heading, VStack } from "@chakra-ui/react";
import { ReactNode } from "react";

import { Restricted } from "@/app/components/Restricted";
import { DelayedSpinner } from "@/common/components/DelayedSpinner";
import GithubIntegrationForm from "@/integration/components/github/GithubIntegrationForm";
import LinearIntegrationForm from "@/integration/components/linear/LinearIntegrationForm";
import { useGithubConnection } from "@/integration/data/useGithubConnection";
import { useLinearConnection } from "@/integration/data/useLinearConnection";
import { useSlackConnection } from "@/integration/data/useSlackConnection";

import SlackIntegrationForm from "./slack/SlackIntegrationForm";

export default function Integrations() {
  const { data: linearConnection, isLoading: linearLoading } =
    useLinearConnection();
  const { data: githubConnection, isLoading: githubLoading } =
    useGithubConnection();
  const { data: slackConnection, isLoading: slackLoading } =
    useSlackConnection();

  const isLoading = linearLoading || githubLoading || slackLoading;

  const activeIntegrations: ReactNode[] = [];
  const availableIntegrations: ReactNode[] = [];

  (slackConnection ? activeIntegrations : availableIntegrations).push(
    <SlackIntegrationForm key="slack" />,
  );

  (linearConnection ? activeIntegrations : availableIntegrations).push(
    <LinearIntegrationForm key="linear" />,
  );

  (githubConnection ? activeIntegrations : availableIntegrations).push(
    <GithubIntegrationForm key="github" />,
  );

  return (
    <Flex direction="column" gap={4} maxW="wideForm">
      <Restricted alertStyle="callout" role="admin">
        <VStack align="flex-start" spacing={8} w="full">
          {isLoading ? (
            <Center h="lg">
              <DelayedSpinner />
            </Center>
          ) : (
            <>
              {activeIntegrations.length > 0 && (
                <VStack align="flex-start" spacing={4} w="full">
                  <Heading size="md">Active</Heading>
                  {activeIntegrations}
                </VStack>
              )}
              {availableIntegrations.length > 0 && (
                <VStack align="flex-start" spacing={4} w="full">
                  <Heading size="md">Available</Heading>
                  {availableIntegrations}
                </VStack>
              )}
            </>
          )}
        </VStack>
      </Restricted>
    </Flex>
  );
}
